// (ملف جديد: src/WebhookSetupPage.js)
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from './lib/supabaseAuth';
import { callSaveWebhookSecrets } from './firebase';

// ده كومبوننت جديد بيستقبل 3 حاجات: اليوزر، وبيانات العميل، والدالة اللي بتحدث البيانات
function WebhookSetupPage({ user, clientData, setClientData }) {
  const [secret, setSecret] = useState('');
  const [feedbackSecret, setFeedbackSecret] = useState(''); // 🔥 جديد: للـ Feedback webhook
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut();
      navigate('/');
    } catch (error) {
      console.error('خطأ في تسجيل الخروج:', error);
    }
  };

  // 1. بنحدد الرابط حسب نوع المنصة (shopify أو easyorder)
  const platform = clientData.platform || 'shopify'; // default to shopify
  
  // 🔥 تحديد الـ Webhook الصحيح حسب المنصة
  const webhookConfig = platform === 'easyorder' ? {
    id: '90b3766d-c689-41a4-b69c-b784f5715456',
    path: 'easy_order-hook-alsayes3'
  } : {
    id: '213c991d-9702-406b-9908-a621481ca80d',
    path: 'shopify-hook-alsayes3'
  };
  
  // 🔥 Feedback Webhook للـ EasyOrder
  const feedbackWebhookConfig = {
    id: '1335fb05-b50b-46a1-ad94-55eeb60b9b6a',
    path: 'easyorders-webhook'
  };
  
  const fullWebhookURL = `https://n8n2.dafaiagency.shop/webhook/${webhookConfig.id}/${webhookConfig.path}/${clientData.webhook_path_id}`;
  const fullFeedbackWebhookURL = platform === 'easyorder' ? `https://n8n2.dafaiagency.shop/webhook/${feedbackWebhookConfig.id}/${feedbackWebhookConfig.path}/${clientData.webhook_feedback_id || clientData.webhook_path_id}` : '';

  // 2. عناوين وإرشادات مختلفة حسب المنصة
  const platformInstructions = platform === 'shopify' ? {
    title: '🎉 خطوة واحدة أخيرة يا',
    steps: [
      'اذهب إلى لوحة تحكم شوبيفاي (Shopify Admin).',
      'اذهب إلى Settings > Notifications.',
      'انزل لآخر الصفحة حتى تجد قسم "Webhooks".',
      'اضغط "Create webhook".',
      'في خانة "Event"، اختر "Order creation".',
      'في خانة "Format"، اختر "JSON".',
      'في خانة "URL"، انسخ الرابط التالي:',
    ],
    secretLabel: 'Shopify Shared Secret',
    secretField: 'shopify_shared_secret',
    secretInstructions: 'بعد الضغط على "Save" في شوبيفاي، هيظهرلك "Signing secret". انسخه والصقه في الخانة اللي تحت، واضغط "حفظ وتفعيل".',
  } : {
    title: '🎉 خطوة واحدة أخيرة يا',
    steps: [
      '1. اذهب إلى لوحة تحكم EasyOrder.',
      '2. اذهب إلى Settings > Integrations.',
      '3. اذهب إلى Public API.',
      '4. اضغط "Webhook".',
    ],
    secretLabel: 'EasyOrder Secret Key',
    secondSecretLabel: 'EasyOrder Feedback Secret Key', // 🔥 جديد
    secretField: 'easyorder_shared_secret',
    feedbackSecretField: 'easyorder_feedback_secret', // 🔥 جديد
    secretInstructions: 'بعد حفظ الويب هوك في EasyOrder، هيظهرلك "Secret Key". انسخه والصقه في الخانة المقابلة.',
  };

  const handleSaveSecret = async (e) => {
    e.preventDefault();
    if (!secret) {
      setError('لا يمكن ترك حقل Order Secret فارغاً');
      return;
    }
    
    // 🔥 للـ EasyOrder: التحقق من أن Feedback Secret مملوء أيضاً
    if (platform === 'easyorder' && !feedbackSecret) {
      setError('لا يمكن ترك حقل Feedback Secret فارغاً');
      return;
    }
    
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      // 2/3. الأسرار دي (shopify_shared_secret/easyorder_shared_secret/
      // easyorder_feedback_secret) مستبعدة عمدًا من whitelist
      // update_my_brand_settings (شوف MIGRATION_MAP.md §6) — الحفظ بيعدّي
      // عبر راوت سيرفر مخصّص (service_role)، مش update مباشر.
      const updateData = {
        [platformInstructions.secretField]: secret
      };

      // 🔥 إضافة Feedback secret للـ EasyOrder
      if (platform === 'easyorder') {
        updateData[platformInstructions.feedbackSecretField] = feedbackSecret;
      }

      await callSaveWebhookSecrets({
        brand: clientData.brand_name,
        secrets: updateData,
      });

      // 4. (مهم) بنحدث الـ state في الداش بورد عشان الصفحة تتغير
      setClientData(prevData => ({
        ...prevData,
        ...updateData
      }));

      setSuccess('تم الحفظ بنجاح! جاري تحويلك للداشبورد...');
      
      // تحديث الصفحة بعد ثانية واحدة
      setTimeout(() => {
        window.location.reload();
      }, 1000);

    } catch (err) {
      console.error(err);
      setError('حدث خطأ أثناء الحفظ. حاول مرة أخرى.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={setupStyles.container}>
      <div style={setupStyles.card}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <button onClick={handleLogout} style={setupStyles.logoutButton}>
            تسجيل خروج
          </button>
          <h2 style={{color: '#00b4d8', margin: 0}}>
            {platformInstructions.title} {clientData.brand_name}!
          </h2>
        </div>
        <p style={{color: '#f8f8f2', fontSize: '16px', marginBottom: '20px'}}>
          تم إنشاء حسابك بنجاح. لتفعيل الخدمة، يرجى إتباع الآتي:
        </p>
        
        {/* 🎥 فيديو توضيحي للـ EasyOrder */}
        {platform === 'easyorder' && (
          <div style={{ marginBottom: '25px', textAlign: 'center' }}>
            <div style={{
              padding: '15px',
              background: 'rgba(139, 233, 253, 0.1)',
              borderRadius: '10px',
              border: '2px solid #8be9fd',
              marginBottom: '15px'
            }}>
              <h3 style={{ color: '#8be9fd', margin: '0 0 10px 0', fontSize: '18px' }}>
                🎥 شرح بالفيديو: كيفية إعداد Webhooks في EasyOrder
              </h3>
              <p style={{ color: '#f8f8f2', fontSize: '14px', margin: '0 0 15px 0' }}>
                مش عارف تعمل الخطوات؟ شاهد الفيديو التوضيحي 👇
              </p>
              <iframe
                src="https://drive.google.com/file/d/1-lhcx5NVHVk2jUcZXJMsfDr_DX3ZxprI/preview"
                width="100%"
                height="400"
                allow="autoplay"
                style={{
                  borderRadius: '8px',
                  border: '2px solid #44475a',
                  maxWidth: '700px'
                }}
                title="شرح إعداد Webhooks في EasyOrder"
              />
            </div>
          </div>
        )}
        
        <ol style={setupStyles.list}>
          {platformInstructions.steps.map((step, index) => (
            <li key={index}>{step}</li>
          ))}
        </ol>

        {/* 🔥 Webhook 1: Orders */}
        <div style={{...setupStyles.webhookSection, marginTop: '25px'}}>
          <h3 style={{color: '#50fa7b', marginBottom: '15px', fontSize: '18px'}}>
            📦 Webhook #1: استقبال الأوردرات الجديدة
          </h3>
          <p style={{color: '#f8f8f2', fontSize: '14px', marginBottom: '10px'}}>
            {platform === 'easyorder' ? (
              <>5. في Event Type، اختر: <strong style={{color: '#f1fa8c'}}>Order</strong></>
            ) : (
              'استخدم هذا الـ Webhook لاستقبال الأوردرات الجديدة'
            )}
          </p>
          <input 
            type="text" 
            readOnly 
            value={fullWebhookURL} 
            style={setupStyles.input} 
          />
          <button onClick={() => navigator.clipboard.writeText(fullWebhookURL)} style={setupStyles.copyButton}>
            📋 نسخ رابط Orders Webhook
          </button>
        </div>

        {/* 🔥 Webhook 2: Feedback (للـ EasyOrder فقط) */}
        {platform === 'easyorder' && (
          <div style={{...setupStyles.webhookSection, marginTop: '25px', borderColor: '#bd93f9'}}>
            <h3 style={{color: '#bd93f9', marginBottom: '15px', fontSize: '18px'}}>
              ⭐ Webhook #2: طلبات التقييم (Feedback)
            </h3>
            <p style={{color: '#f8f8f2', fontSize: '14px', marginBottom: '10px'}}>
              6. أنشئ Webhook جديد، في Event Type، اختر: <strong style={{color: '#f1fa8c'}}>Order Status Update</strong>
            </p>
            <input 
              type="text" 
              readOnly 
              value={fullFeedbackWebhookURL} 
              style={setupStyles.input} 
            />
            <button onClick={() => navigator.clipboard.writeText(fullFeedbackWebhookURL)} style={{...setupStyles.copyButton, backgroundColor: '#bd93f9'}}>
              📋 نسخ رابط Feedback Webhook
            </button>
          </div>
        )}

        <div style={setupStyles.secretSection}>
          <p style={setupStyles.secretTitle}>📋 الخطوة الأخيرة:</p>
          <p style={setupStyles.secretInstructions}>
            {platformInstructions.secretInstructions}
          </p>
        </div>

        <form onSubmit={handleSaveSecret}>
          {/* Secret للـ Orders */}
          <div style={{marginBottom: '15px'}}>
            <label style={{color: '#50fa7b', fontSize: '14px', fontWeight: 'bold', display: 'block', marginBottom: '8px'}}>
              {platformInstructions.secretLabel} (Orders Webhook)
            </label>
            <input 
              type="text" 
              placeholder={platformInstructions.secretLabel}
              value={secret}
              onChange={(e) => setSecret(e.target.value)}
              style={setupStyles.input}
            />
          </div>

          {/* 🔥 Secret للـ Feedback (للـ EasyOrder فقط) */}
          {platform === 'easyorder' && (
            <div style={{marginBottom: '15px'}}>
              <label style={{color: '#bd93f9', fontSize: '14px', fontWeight: 'bold', display: 'block', marginBottom: '8px'}}>
                {platformInstructions.secondSecretLabel} (Feedback Webhook)
              </label>
              <input 
                type="text" 
                placeholder={platformInstructions.secondSecretLabel}
                value={feedbackSecret}
                onChange={(e) => setFeedbackSecret(e.target.value)}
                style={setupStyles.input}
              />
            </div>
          )}

          <button type="submit" disabled={loading} style={setupStyles.saveButton}>
            {loading ? 'جاري الحفظ...' : 'حفظ وتفعيل'}
          </button>
        </form>
        {error && <p style={{ color: '#ff5555', marginTop: '10px' }}>{error}</p>}
        {success && <p style={{ color: '#50fa7b', marginTop: '10px' }}>{success}</p>}
      </div>
    </div>
  );
}

// ستايلات لصفحة الإعداد
const setupStyles = {
  container: {
    padding: '20px',
    background: '#121212',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  card: {
    backgroundColor: '#1e1e2f',
    borderRadius: '12px',
    boxShadow: '0 8px 32px rgba(0, 180, 216, 0.15)',
    border: '1px solid #44475a',
    padding: '35px',
    maxWidth: '750px',
    width: '100%',
    textAlign: 'right',
  },
  list: {
    textAlign: 'right',
    paddingRight: '20px',
    lineHeight: '1.8',
    color: '#f8f8f2',
    fontSize: '15px',
  },
  code: {
    backgroundColor: '#282a36',
    padding: '2px 6px',
    borderRadius: '4px',
    fontFamily: 'monospace',
    color: '#50fa7b',
  },
  webhookSection: {
    padding: '20px',
    backgroundColor: '#282a36',
    borderRadius: '8px',
    borderRight: '4px solid #50fa7b',
  },
  input: {
    width: '100%',
    padding: '12px',
    margin: '10px 0',
    boxSizing: 'border-box',
    border: '1px solid #44475a',
    borderRadius: '4px',
    fontSize: '14px',
    textAlign: 'left',
    background: '#282a36',
    color: '#f8f8f2',
  },
  copyButton: {
    width: '100%',
    padding: '10px',
    backgroundColor: '#6272a4',
    color: '#f8f8f2',
    border: '1px solid #44475a',
    cursor: 'pointer',
    fontSize: '15px',
    fontWeight: 'bold',
    borderRadius: '4px',
  },
  saveButton: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#50fa7b',
    color: '#282a36',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'pointer',
    fontWeight: 'bold',
  },
  secretSection: {
    marginTop: '30px',
    marginBottom: '20px',
    padding: '20px',
    backgroundColor: '#282a36',
    borderRight: '4px solid #00b4d8',
    borderRadius: '6px',
  },
  secretTitle: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#00b4d8',
    marginBottom: '10px',
  },
  secretInstructions: {
    fontSize: '15px',
    lineHeight: '1.8',
    color: '#f8f8f2',
    margin: 0,
  },
  logoutButton: {
    padding: '10px 20px',
    backgroundColor: '#ff5555',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    fontSize: '14px',
    cursor: 'pointer',
    fontWeight: 'bold',
    transition: 'all 0.3s ease',
  }
};

export default WebhookSetupPage;